import { Component, OnInit } from '@angular/core';
import { TranslateService } from 'ng2-translate';

@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.css']
})
export class ContactFormComponent implements OnInit {

  constructor(private translate: TranslateService) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/contact/contact-form/contact-form.component.ts